import { schema } from "normalizr";

export const seoSchema = new schema.Entity("seo", {}, {idAttribute: 'path'});

